<template>
  <layout-vertical>
    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from "@core/layouts/layout-vertical/LayoutVertical.vue";
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from "../components/Navbar.vue";
import Users from "@/Apis/Users";

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  mounted: function () {
    this.setOnline();
     this.interval = setInterval(function() {
                this.setOnline()
            }.bind(this), 60000);
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    };
  },
  created() {
    clearInterval(window.setOnlineInterval);
  },
  methods: {
    setOnline: function () {
       
        new Users().setOnline();
      
    },
  },
};
</script>
